export const dictionaryES = {
  Book: "Reservar",
  Continue: "Continuar",
  "Continue to checkout": "Continuar al pago",
  "Enhance your booking": "Mejora tu reserva",
  "/hr": "/hora",
  hr: "hora",
  hrs: "horas",
  people: "personas",
  person: "persona",
  Location: "Ubicación",
  "City: Any": "Ciudad: Cualquiera",
  "State: Any": "Estado: Cualquiera",
  "Location: Any": "Ubicación: Cualquiera",
  "Capacity: Any": "Capacidad: Cualquiera",
  Filter: "Filtrar",
  Filters: "Filtros",
  "{numberOfRooms} rooms found": "{numberOfRooms} salas encontradas",
  "Showing all rooms": "Mostrando todas las salas",
  "1 room found": "1 sala encontrada",
  "No meeting rooms found": "No se encontraron salas de reuniones",
  "Try changing or clearing some of your filters":
    "Intenta cambiar o limpiar algunos de tus filtros",
  "Clear all filters": "Limpiar todos los filtros",
  "Show results": "Mostrar resultados",
  Office: "Oficina",
  "{count} offerings at {locationName}": "{count} ofertas en {locationName}",
  "On Demand": "Bajo demanda",
  Memberships: "Membresías",
  Any: "Cualquiera",
  "Any location": "Cualquier ubicación",
  "Any city": "Cualquier ciudad",
  view: "ver",
  "Meeting rooms": "Salas de reuniones",
  "Event spaces": "Espacios de eventos",
  "Daily offices": "Oficinas diarias",
  "Invitations already sent to:": "Invitaciones ya enviadas a:",
  and: "y",
  "Available on": "Disponible el",
  "Available on {date}": "Disponible el {date}",
  "Best price available today": "Mejor precio disponible hoy",
  "Best price available tomorrow": "Mejor precio disponible mañana",
  "Best price available on {date}": "Mejor precio disponible el {date}",
  "No available space": "No hay espacio disponible",
  "View More": "Ver más",
  "Additional offices at this location":
    "Oficinas adicionales en esta ubicación",
  Floor: "Piso",
  "With window": "Con ventana",
  "Day offices at-{locationName}": "Oficinas diarias en {locationName}",
  "Not sure?": "¿No estás seguro?",
  "Talk with us": "Habla con nosotros",
  "We couldn't get a price for this selection. Please try again.":
    "No pudimos calcular un precio para esta selección. Inténtalo de nuevo.",
  "We are sorry, but there is no availability for 1 pass":
    "Lo sentimos, pero no hay disponibilidad para 1 pase",
  "We are sorry, but this date is unavailable at this location. Please pick a different date":
    "Lo sentimos, pero esta fecha no está disponible en esta ubicación. Elige otra fecha",
  "We are sorry, but there is no availability for {number of passes} passes":
    "Lo sentimos, pero no hay disponibilidad para {number of passes} pases",
  "and we may be able to help you find a solution.":
    "y podemos ayudarte a encontrar una solución.",
  max: "máximo",
  "Have more questions?": "¿Tienes más preguntas?",
  "Visit our FAQ": "Visita nuestras FAQ",
  "Frequently asked questions": "Preguntas frecuentes",
  Directions: "Direcciones",
  "is located at": "está ubicado en",
  "Not available": "No disponible",
  Total: "Total",
  to: "a",
  "/day": "/día",
  "/hour": "/hora",
  "/month": "/mes",
  From: "Desde",
  "Quantity:": "Cantidad:",
  Quantity: "Cantidad",
  Save: "Guardar",
  When: "Cuándo",
  Back: "Volver",
  "Please select a location": "Por favor selecciona una ubicación",
  "Please select date range": "Por favor selecciona un rango de fechas",
  "Please select # of entries": "Por favor selecciona # de entradas",
  "Please select date": "Por favor selecciona una fecha",
  "Please select time": "Por favor selecciona una hora",
  "Please select duration": "Por favor selecciona la duración",
  "Minimum duration": "Duración mínima",
  "Minimum {count}": "Mínimo {count}",
  "Minimum {count} per day": "Mínimo {count} por día",
  "Minimum {count} per day, based on guest count":
    "Mínimo {count} por día, según el número de invitados",
  "Minimum {count} per booking": "Mínimo {count} por reserva",
  "Items per day": "Artículos por día",
  "Items per booking": "Artículos por reserva",
  "From {price}/day (min {count}/day)": "Desde {price}/día (mín. {count}/día)",
  "{perDay}/day × {days} · {total}": "{perDay}/día × {days} · {total}",
  "{perDay}/day": "{perDay}/día",
  "{qty} per day × {days} = {items}": "{qty} por día × {days} = {items}",
  "Select at least one day": "Selecciona al menos un día",
  each: "cada uno",
  "Add to booking · {total}": "Añadir a la reserva · {total}",
  "Update booking · {total}": "Actualizar reserva · {total}",
  "{count} is the minimum per day. Use Remove from booking if you don't want {name}.":
    "{count} es el mínimo por día. Usa «Remove from booking» si no quieres {name}.",
  "{count} is the minimum per booking. Use Remove from booking if you don't want {name}.":
    "{count} es el mínimo por reserva. Usa «Remove from booking» si no quieres {name}.",
  "Please select quantity": "Por favor selecciona la cantidad",
  day: "día",
  days: "días",
  "1 day": "1 día",
  "{number of days} days": "{number of days} días",
  "Valid for {numberOfDays} day from purchase":
    "Válido por {numberOfDays} día desde la compra",
  "Valid for {numberOfDays} days from purchase":
    "Válido por {numberOfDays} días desde la compra",
  "1 hour": "1 hora",
  "{number of hours} hours": "{number of hours} horas",
  "1 entry": "1 entrada",
  "{number of entries} entries": "{number of entries} entradas",
  entry: "entrada",
  entries: "entradas",
  hour: "hora",
  hours: "horas",
  Close: "Cerrar",
  Update: "Actualizar",
  Amenities: "Servicios",
  "per guest": "por invitado",
  "fixed rate": "tarifa fija",
  "per item": "por artículo",
  "for this space": "por este espacio",
  "per day": "por día",
  "per booking": "por reserva",
  "per guest, daily": "por invitado, diario",
  "per item, daily": "por artículo, diario",
  Included: "Incluido",
  "Add-ons": "Complementos",
  "Powered by": "Desarrollado por",
  Privacy: "Privacidad",
  Terms: "Términos",
  QTY: "CDAD",
  Subtotal: "Total parcial",
  "Cancel for free up to {duration} before your booking":
    "Cancela gratis hasta {duration} antes de tu reserva",
  "Cancel for free up to ": "Cancela gratis hasta ",
  "Cancel for free up to {time} the day before your booking":
    "Cancela gratis hasta {time} el día anterior a tu reserva",
  "Fits: {capacity} people max": "Capacidad: máximo {capacity} personas",
  "Free cancellation before {time} on {date}":
    "Cancelación gratuita antes de las {time} el {date}",
  "This booking is non-refundable.": "No reembolsable.",
  "{max} max": "máximo {max}",
  "Up to {capacity} people": "Hasta {capacity} personas",
  "Up to {capacity} person": "Hasta {capacity} persona",
  "End time": "Hora de finalización",
  "Start time": "Hora de inicio",
  "View all images": "Ver todas las imágenes",
  "Full name": "Nombre completo",
  "Phone number": "Número de teléfono",
  Email: "Correo electrónico",
  "Number of expected guests": "Número de invitados esperados",
  "Company Name": "Nombre de la empresa",
  "Street address": "Dirección",
  "City / Town": "Ciudad",
  "State / Province / Region": "Estado / Provincia / Región",
  "State / Province / Region (optional)":
    "Estado / Provincia / Región (opcional)",
  "Postal code": "Código postal",
  Country: "País",
  "Tax / VAT / ID number": "Número de identificación fiscal / IVA",
  "Enter a promo code": "Ingresa un código promocional",
  "Promo code": "Código promocional",
  "Payment details": "Detalles del pago",
  "Confirm and Pay": "Confirmar y pagar",
  "You won't be charged unless your request is accepted.":
    "No se te cobrará a menos que tu solicitud sea aceptada.",
  "Request to Book": "Solicitar reserva",
  "Request to Subscribe": "Solicitar suscripción",
  "Confirm and subscribe": "Confirmar y suscribir",
  "Continue to payment": "Continuar al pago",
  "This crash has been reported to us and we will work on resolving the issue as quickly as possible.":
    "Este error ha sido reportado y trabajaremos en resolverlo lo más rápido posible.",
  "By clicking on Confirm and Pay I agree to the":
    "Al hacer clic en Confirmar y pagar, acepto los",
  "terms and conditions": "términos y condiciones",
  "Billing details": "Detalles de facturación",
  "Your details": "Tus detalles",
  "Check here to indicate that you have read and agreed to the":
    "Marca aquí para indicar que has leído y aceptado los",
  Apply: "Aplicar",
  "Submitting your request": "Enviando tu solicitud",
  "Please add your full name": "Por favor agrega tu nombre completo",
  "Please agree to the terms and conditions":
    "Por favor acepta los términos y condiciones",
  "Please add your company name": "Por favor agrega el nombre de tu empresa",
  "Please add your phone number": "Por favor agrega tu número de teléfono",
  "Please enter valid phone number":
    "Por favor ingresa un número de teléfono válido",
  "Please add your email": "Por favor agrega tu correo electrónico",
  "Please enter valid email": "Por favor ingresa un correo electrónico válido",
  "Please add billing street address":
    "Por favor agrega la dirección de facturación",
  "Please add billing city": "Por favor agrega la ciudad de facturación",
  "Please add billing state / province / region":
    "Por favor agrega el estado / provincia / región de facturación",
  "Please add postal code": "Por favor agrega el código postal",
  "Please add billing country": "Por favor agrega el país de facturación",
  "Please add tax information": "Por favor agrega la información fiscal",
  "Please enter credit card info":
    "Por favor ingresa la información de la tarjeta de crédito",
  "Let's talk": "Hablemos",
  "We would be happy to provide you with more information and answer your specific office needs.":
    "Estaremos encantados de proporcionarte más información y responder a tus necesidades específicas de oficina.",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "How can we help?": "¿Cómo podemos ayudarte?",
  Submit: "Enviar",
  "Could not get order confirmation":
    "No se pudo obtener la confirmación del pedido",
  "Your payment could not be completed. Please check your card details or try another payment method.":
    "No se pudo completar tu pago. Revisa los datos de tu tarjeta o prueba con otro método de pago.",
  "Someone else just booked this space. No payment was taken — the hold on your card will disappear shortly.":
    "Otra persona acaba de reservar este espacio. No se realizó ningún cobro: la retención en tu tarjeta desaparecerá en breve.",
  "An add-on you selected just sold out for that date. No payment was taken — the hold on your card will disappear shortly.":
    "Un complemento que seleccionaste acaba de agotarse para esa fecha. No se realizó ningún cobro: la retención en tu tarjeta desaparecerá en breve.",
  "Choose another time": "Elige otro horario",
  "Stripe was not loaded": "Stripe no se cargó",
  "The session has expired. Please refresh the page and try again.":
    "La sesión ha expirado. Por favor, actualiza la página e inténtalo de nuevo.",
  "Card component not found": "Componente de tarjeta no encontrado",
  "Payment unsuccessful": "Pago fallido",
  "Redirecting you to confirmation page":
    "Redirigiendo a la página de confirmación",
  Payment: "Pago",
  "Confirmed without payment": "Confirmado sin pago",
  "N/A": "N/D",
  "Ending with {last4}": "Terminando en {last4}",
  "Confirmed!": "¡Confirmado!",
  "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.":
    "Gracias por reservar con nosotros. Se ha enviado un correo de confirmación a {email}. Esperamos verte pronto.",
  "Payment method": "Método de pago",
  "Phone (optional)": "Teléfono (opcional)",
  "Please enter at least one attendee.":
    "Por favor ingresa al menos un asistente.",
  "Invite Attendees": "Invitar asistentes",
  Message: "Mensaje",
  Name: "Nombre",
  "e.g. Looking forward to seeing you at {offeringName}!":
    "ej. ¡Nos vemos pronto en {offeringName}!",
  "Add your attendees below. Their invitation email automatically includes the location, address, and directions.":
    "Añade a tus asistentes abajo. Su correo de invitación incluye automáticamente la ubicación, la dirección y cómo llegar.",
  "View Invitation": "Ver invitación",
  "Will there be others joining you?": "¿Habrá otros que se unan a ti?",
  "The invitation email automatically includes the location, address, and directions.":
    "El correo de invitación incluye automáticamente la ubicación, la dirección y cómo llegar.",
  attendee: "asistente",
  attendees: "asistentes",
  "Please add email": "Por favor agrega el correo electrónico",
  "Please add name": "Por favor agrega el nombre",
  "Invitation sent!": "¡Invitación enviada!",
  "An email invitation have been sent to your attendees with details and directions.":
    "Se ha enviado una invitación por correo electrónico a tus asistentes con detalles y direcciones.",
  Attendees: "Asistentes",
  "Attendees:": "Asistentes:",
  Done: "Hecho",
  "Invitation sent to 1 attendee": "Invitación enviada a 1 asistente",
  "Invitation sent to {number of attendees} attendees":
    "Invitación enviada a {number of attendees} asistentes",
  "{number of hours}": "{number of hours}",
  "{number of entries}": "{number of entries}",
  "{number of days}": "{number of days}",
  "Sorry, we couldn't find anything matching your search.":
    "Lo sentimos, no pudimos encontrar nada que coincida con tu búsqueda.",
  "Reset Filter": "Restablecer filtro",
  "Select a location": "Selecciona una ubicación",
  "Select quantity": "Selecciona cantidad",
  "Select number of guests": "Selecciona número de invitados",
  "Please select the number of guests":
    "Por favor selecciona el número de invitados",
  "Select # of entries": "Selecciona # de entradas",
  "{productTypeName} at {locationName}": "{productTypeName} en {locationName}",
  "{productTypeName} to {locationName}": "{productTypeName} en {locationName}",
  Capacity: "Capacidad",
  "Capacity:": "Capacidad:",
  "Image for illustration purpose only": "Imagen solo para fines ilustrativos",
  "Send Invitations": "Enviar invitaciones",
  ILS: "ILS",
  "on {cancelledAt}.": "el {cancelledAt}.",
  "Order cancelled": "Pedido cancelado",
  "Cancelled and refunded ": "Cancelado y reembolsado ",
  "Cancel Order": "Cancelar pedido",
  "Cancel available in {time}": "Cancelación disponible en {time}",
  "Cancel temporarily unavailable while invoice is processing":
    "Cancelación temporalmente no disponible mientras se procesa la factura",
  "Finalizing the invoice with your space provider. Cancellation will be available shortly.":
    "Estamos finalizando la factura con tu proveedor de espacio. La cancelación estará disponible en breve.",
  "Cancellation temporarily unavailable, available in approximately {minutes} minutes":
    "Cancelación temporalmente no disponible, disponible en aproximadamente {minutes} minutos",
  "Cancellation now available": "Cancelación ya disponible",
  Cancellation: "Cancelación",
  "Are you sure you want to cancel and get a refund? This cannot be un-done.":
    "¿Estás seguro de que quieres cancelar y obtener un reembolso? Esto no se puede deshacer.",
  "No, do not cancel": "No, no cancelar",
  "Yes, Cancel & Refund": "Sí, cancelar y reembolsar",
  "Or call us at:": "O llámanos al:",
  "Additional Products": "Productos adicionales",
  "Book now": "Reservar ahora",
  "Subscribe now": "Suscribirse ahora",
  "Coming Soon": "Próximamente",
  "Manage bookings": "Gestionar reservas",
  "Learn more": "Más información",
  Daily: "Diario",
  "1 Daily Pass": "1 Pase Diario",
  "Unlimited access": "Acceso ilimitado",
  Confirm: "Confirmar",
  "Start from": "Desde",
  "There are no offices available for the selected capacity.":
    "No hay oficinas disponibles para la capacidad seleccionada.",
  Date: "Fecha",
  Clear: "Limpiar",
  "Our Customers Say": "Lo que dicen nuestros clientes",
  "Review from Google": "Reseña de Google",
  phoneNumberOptional: "Número de teléfono (opcional)",
  "Please add your first name": "Por favor agrega tu nombre",
  "Please add your last name": "Por favor agrega tu apellido",
  "Please enter a valid email":
    "Por favor ingresa un correo electrónico válido",
  "Please enter a valid phone number":
    "Por favor ingresa un número de teléfono válido",
  "Message can't be blank": "El mensaje no puede estar vacío",
  bookingReasonTitle: "¿Cuál es el motivo de tu reserva?",
  bookingReasonTitleOptional: "Cuéntenos más sobre su reserva (Opcional)",
  specialInstructionsTitle: "Instrucciones especiales (Opcional)",
  specialInstructionsDisplayTitle: "Instrucciones especiales",
  "E.g Catering, Beverages or equipment":
    "Por ejemplo: Catering, Bebidas o equipos",
  missingBookingReasonError: "Por favor agrega el motivo de tu reserva",
  bookingReason: "Motivo de la reserva",
  selectADate: "Selecciona una fecha",
  "More to explore...": "Más por explorar...",
  backTo: "Volver a",
  showFewerAmenities: "Mostrar menos servicios",
  showAllAmenities: "Mostrar todos los servicios",
  "Show less": "Mostrar menos",
  needHelp: "¿Necesitas ayuda?",
  Home: "Inicio",
  Guest: "Invitado",
  Guests: "Invitados",
  "Guest {capacity}": "{capacity} Invitado",
  "Guests {capacity}": "{capacity} Invitados",
  copy: "Copiar",
  copied: "Copiado",
  generalInformation: "Información general",
  "Single pass": "Pase individual",
  "Select capacity": "Seleccionar capacidad",
  "Enter a code": "Ingresa un código",
  "Update booking details": "Actualizar detalles de la reserva",
  "Select booking details": "Seleccionar detalles de la reserva",
  "Book this space": "Reservar este espacio",
  "Check availability": "Verificar disponibilidad",
  "Select date": "Seleccionar fecha",
  "No start dates are available": "No hay fechas de inicio disponibles",
  "Every date in this membership's start date window is closed or unavailable. Please contact us to arrange a start date.":
    "Todas las fechas del periodo de inicio de esta membresía están cerradas o no disponibles. Contáctenos para acordar una fecha de inicio.",
  City: "Ciudad",
  "Select a city": "Seleccionar una ciudad",
  "Select a country": "Seleccionar un país",
  "Book here": "Reservar aquí",
  somethingWentWrong: "Algo salió mal",
  availabilityFetchingError:
    "No podemos verificar las salas disponibles en este momento, por favor inténtalo más tarde.",
  "Cancellation policy": "Política de cancelación",
  "{percent}% refund if cancelled {duration} before booking":
    "{percent}% de reembolso si se cancela {duration} antes de la reserva",
  "{percent}% refund if cancelled by {time} the day before your booking":
    "{percent}% de reembolso si se cancela antes de las {time} el día anterior a tu reserva",
  "Payment information": "Información de pago",
  "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.":
    "Gracias {firstName}, nos pondremos en contacto contigo lo antes posible y responderemos a tu correo electrónico en {email}.",
  "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ":
    "Al proporcionar la información de tu tarjeta, autorizas a {partnerName} a cargar tu tarjeta para pagos futuros de acuerdo con sus ",
  "Terms of Service": "Términos de servicio",
  share: "Compartir",
  backToAllOffering: "Volver a todas las ofertas",
  backToAllMemberships: "Volver a todas las membresías",
  Accessibility: "Accesibilidad",
  priceInfoMessage: "El precio se basa en la disponibilidad",
  priceInfoMessageV2: "El precio varía según la disponibilidad.",
  priceChargedMessage: "No se te cobrará todavía.",
  from: "desde",
  "Already have a reservation": "¿Ya tienes una reserva?",
  Yes: "Sí",
  No: "No",
  "You are now a {partnerName} member. A confirmation email has been sent to {email} with further instructions to activate your membership. We are looking forward to seeing you soon.":
    "Ahora eres miembro de {partnerName}. Se ha enviado un correo de confirmación a {email} con instrucciones adicionales para activar tu membresía. Esperamos verte pronto.",
  "Welcome to {partnerName}!": "¡Bienvenido a {partnerName}!",
  "We've chosen the best possible price for you based on your selections":
    "Hemos elegido el mejor precio posible para ti según tus selecciones",
  "Available spaces": "Espacios disponibles",
  "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30":
    "Aquí hay algunos espacios adicionales que podrían interesarte, disponibles durante nuestro horario laboral de 09:00-17:30",
  "To get the most out of your Coworking membership, you'll need to activate your member portal. To get started, click the button below to set your password and login.":
    "Para aprovechar al máximo tu membresía de Coworking, necesitarás activar tu portal de miembro. Para comenzar, haz clic en el botón de abajo para establecer tu contraseña e iniciar sesión.",
  "To access your member portal, login with the same credentials you used for your multi passes.":
    "Para acceder a tu portal de miembro, inicia sesión con las mismas credenciales que usaste para tus pases múltiples.",
  "Login to your member portal to access your new membership.":
    "Inicia sesión en tu portal de miembro para acceder a tu nueva membresía.",
  "Activate your member portal": "Activar tu portal de miembro",
  "Set my password": "Establecer mi contraseña",
  Login: "Iniciar sesión",
  "Book {numberOfHours}+ hours, save {savingValue} on select dates":
    "Reserva {numberOfHours}+ horas, ahorra {savingValue} en fechas seleccionadas",
  "Membership options": "Opciones de membresía",
  Locations: "Ubicaciones",
  "Book {numberOfHours}+ hours to unlock {savingDisplay} off.":
    "Reserva {numberOfHours}+ horas para desbloquear {savingDisplay} de descuento.",
  "before VAT per day": " antes de IVA /día",
  "before VAT per hour": " antes de IVA /hora",
  "before VAT": " antes de IVA",
  "You're saving {price}": "Estás ahorrando {price}",
  "Clear filters": "Limpiar filtros",
  "Need more flexibility? Discover the benefits of memberships today!":
    "¿Necesitas más flexibilidad? ¡Descubre los beneficios de las membresías hoy!",
  "See details": "Ver detalles",
  Where: "Dónde",
  Anywhere: "Cualquier lugar",
  "{numberOfCities} cities, {numberOfBuildings} buildings":
    "{numberOfCities} ciudades, {numberOfBuildings} edificios",
  "{numberOfStates} states, {numberOfBuildings} buildings":
    "{numberOfStates} estados, {numberOfBuildings} edificios",
  "Clear selection": "Limpiar selección",
  "Clear search": "Borrar búsqueda",
  'No locations match "{query}"': 'Ninguna ubicación coincide con "{query}"',
  "See results": "Ver resultados",
  "Search for a city": "Buscar una ciudad",
  "Search for a state": "Buscar un estado",
  Neighborhood: "Barrio",
  "Select a neighborhood": "Selecciona un barrio",
  "Search for a neighborhood": "Buscar un barrio",
  "{numberOfNeighborhoods} neighborhoods, {numberOfBuildings} buildings":
    "{numberOfNeighborhoods} barrios, {numberOfBuildings} edificios",
  "Book {numberOfHours}+ hours, save {savingDisplay}":
    "Reserva {numberOfHours}+ horas, ahorra {savingDisplay}",
  "Not ready for a membership? Try our workspaces for a day":
    "¿No estás listo para una membresía? Prueba nuestras oficinas por día",
  "Additional fees": "Cargos adicionales",
  "varies by layout": "varía según la distribución",
  "Special instructions": "Instrucciones especiales",
  Hours: "Horas",
  Mon: "Lun",
  Tue: "Mar",
  Wed: "Mié",
  Thu: "Jue",
  Fri: "Vie",
  Sat: "Sáb",
  Sun: "Dom",
  AM: "de la mañana",
  PM: "de la tarde",
  "Similar meeting rooms available for a larger number of guests":
    "Salas de reuniones similares disponibles para un mayor número de invitados",
  "Similar spaces available for a larger number of guests":
    "Espacios similares disponibles para un mayor número de invitados",
  "Similar spaces available at other times":
    "Espacios similares disponibles en otros horarios",
  "Similar spaces available in nearby locations":
    "Espacios similares disponibles en ubicaciones cercanas",
  "Similar meeting rooms available at other times":
    "Salas de reuniones similares disponibles en otros horarios",
  "Similar meeting rooms available in nearby locations":
    "Salas de reuniones similares disponibles en ubicaciones cercanas",
  "Other meeting rooms at {locationName}":
    "Otras salas de reuniones en {locationName}",
  "Other meeting rooms available at the same time":
    "Otras salas de reuniones disponibles en el mismo horario",
  "Looks like there aren't any exact matches.":
    "Parece que no hay coincidencias exactas.",
  "Consider adjusting your filters or browsing similar spaces below.":
    "Considera ajustar tus filtros o explorar espacios similares a continuación.",
  "The dates you selected may be unavailable at this location. Try different dates or clear the date filter.":
    "Es posible que las fechas que seleccionaste no estén disponibles en esta ubicación. Prueba otras fechas o limpia el filtro de fecha.",
  "Clear locations": "Limpiar ubicaciones",
  "Clear number of guests": "Limpiar número de invitados",
  "Clear date": "Limpiar fecha",
  "See all": "Ver todo",
  "Show more": "Mostrar más",
  "2 hours": "2 horas",
  "The promotion code is invalid or has expired.":
    "El código promocional no es válido o ha caducado",
  "Invalid Israel tax id": "ID fiscal de Israel no válido",
  "Clear all": "Limpiar todo",
  Hourly: "Por hora",
  Duration: "Duración",
  "Prices vary by day. Select a date to choose a time.":
    "Los precios varían por día. Selecciona una fecha para elegir una hora.",
  min: "minuto",
  mins: "minutos",
  "1 hr": "1 hora",
  "{numberOfHours} hrs": "{numberOfHours} horas",
  "{numberOfMinutes} mins": "{numberOfMinutes} minutos",
  "You're saving {savingDisplay}!": "¡Ahorras {savingDisplay}!",
  "Billed on or about the first of each month.":
    "Facturado el primero de cada mes o alrededor de esa fecha.",
  "Start date": "Fecha de inicio",
  "I confirm that I have read and accept the terms and conditions":
    "Confirmo que he leído y acepto los términos y condiciones",
  "I agree to the terms of service": "Acepto los términos del servicio",
  "Home location:": "Ubicación principal:",
  "Membership starts:": "La membresía comienza:",
  "Next billing date:": "Próxima fecha de facturación:",
  "Monthly payment": "Pago mensual",
  "Tax rate": "Tasa de impuesto",
  "First month adjustment": "Ajuste del primer mes",
  "First bill total": "Total de la primera factura",
  "After the initial month, you'll be billed {amount}/month on or about the first of the month.":
    "Después del mes inicial, se te facturará {amount}/mes el primero del mes o alrededor de esa fecha.",
  "{percent}% off for your whole membership":
    "{percent}% de descuento durante toda tu membresía",
  "Discounted price for your whole membership":
    "Precio con descuento durante toda tu membresía",
  "Payments are calculated monthly. Your first payment covers the remaining days for the current month. Afterwards, you'll be billed on or about the first of the month.":
    "Los pagos se calculan mensualmente. Tu primer pago cubre los días restantes del mes actual. Después de eso, se te facturará el primero del mes o alrededor de esa fecha.",
  "First {cycles} months payment": "Pago de los primeros {cycles} meses",
  "loading...": "cargando...",
  "Continue with Payment": "Continuar con el pago",
  "Promo code copied to clipboard!":
    "¡Código promocional copiado al portapapeles!",
  "Thank you for signing up!": "¡Gracias por registrarte!",
  "Your {savingDisplay} off code is":
    "Tu código de descuento del {savingDisplay} es",
  "Your promotion code will be applied automatically at checkout.":
    "Su código de promoción se aplicará automáticamente al momento del pago.",
  "Please provide a valid email.":
    "Por favor proporcione un correo electrónico válido.",
  "Not now": "Ahora no",
  "Daily rate includes {bookable_start_time} - {bookable_end_time} access":
    "La tarifa diaria incluye acceso de {bookable_start_time} a {bookable_end_time}",
  "Get {savingDisplay} off your next order!":
    "¡Obtén un {savingDisplay} de descuento en tu próximo pedido!",
  "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!":
    "Regístrate para recibir promociones y descuentos exclusivos, ¡y recibe un {savingDisplay} de descuento en tu próximo pedido!",
  "Sign up": "Inscribirse",
  "By signing up, you agree to receive emails related to your discount. One discount per customer/email. Not combinable with other offers.":
    "Al registrarte, aceptas recibir correos electrónicos relacionados con tu descuento. Un descuento por cliente/correo electrónico. No combinable con otras ofertas.",
  "{savingDisplay} off applied at checkout":
    "{savingDisplay} de descuento aplicado al finalizar la compra",
  "Get {savingDisplay} Off!": "¡Obtén un {savingDisplay} de descuento!",
  "Your promo code has been applied!":
    "¡Tu código promocional ha sido aplicado!",
  "Checking available start times...":
    "Comprobando horarios de inicio disponibles...",
  "No available start times for this date.":
    "No hay horarios de inicio disponibles para esta fecha.",
  "We'll show rooms that fit": "Mostraremos salas que se ajusten a ",
  "and more spacious options if available.":
    "y opciones más espaciosas si están disponibles.",
  "{count}+ people": "{count}+ personas",
  "event spaces": "espacios para eventos",
  "Contact us": "Contáctenos",
  "For larger groups, explore our": "Para grupos más grandes, explora nuestros",
  "for larger groups": "para grupos más grandes",
  Who: "Quién",
  "Any number of people": "Cualquier número de personas",
  "contact us": "contáctenos",
  or: "o",
  "Enter the minimum or expected number of people":
    "Ingresa el número mínimo o esperado de personas",
  "Choose a city or location first to allow date and time filtering":
    "Elige primero una ciudad o ubicación para permitir el filtrado por fecha y hora",
  "Clear start time": "Limpiar hora de inicio",
  "Clear duration": "Limpiar duración",
  "Select a location to filter by date":
    "Selecciona una ubicación para filtrar por fecha",
  "Checkout session expired": "Sesión de pago expirada",
  "Your checkout session has expired. Please refresh your page.":
    "Tu sesión de pago ha expirado. Por favor, actualiza la página.",
  "Refresh Page": "Actualizar página",
  "Order is being disputed": "El orden está en disputa",
  "Order was disputed": "La orden fue disputada",
  "Please add your membership number":
    "Por favor agrega tu número de membresía",
  "Please enter only ten digits": "Por favor ingresa solo diez dígitos",
  "Membership details": "Detalles de la membresía",
  "Member ID Barcode": "Código de barras de ID de miembro",
  "Confirm and Join Now": "Confirmar y unirse ahora",
  Category: "Categoría",
  optional: "opcional",
  "Discount subject to date availability and for meeting rooms only":
    "Descuentos sujetos a disponibilidad en fechas y solo para salas de reuniones",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to book, not a guaranteed reservation. You will receive a confirmation email at {email} once your booking is approved.":
    "Gracias por tu solicitud. Revisaremos los detalles y confirmaremos la disponibilidad pronto. Esta es una solicitud para reservar, no una reserva garantizada. Recibirás un correo de confirmación a {email} una vez que tu reserva sea aprobada.",
  "Thank you for your request. We will review the details and confirm availability shortly. This is a request to subscribe, not a guaranteed subscription. You will receive a confirmation email at {email} once your subscription is approved.":
    "Gracias por tu solicitud. Revisaremos los detalles y confirmaremos la disponibilidad pronto. Esta es una solicitud para suscribirse, no una suscripción garantizada. Recibirás un correo de confirmación a {email} una vez que tu suscripción sea aprobada.",
  "Request Submitted!": "Solicitud enviada!",
  // Amenity management (English-only for v1; translations to follow)
  "Add amenity": "Add amenity",
  "Edit amenity": "Edit amenity",
  "Edit description": "Edit description",
  "Remove from library": "Remove from library",
  "Remove from library?": "Remove from library?",
  "Removing…": "Removing…",
  Remove: "Remove",
  "Adding…": "Adding…",
  "Saving…": "Saving…",
  Add: "Add",
  "1. Pick an icon": "1. Pick an icon",
  "2. Describe it": "2. Describe it",
  "Search icons": "Search icons",
  "Search your library": "Search your library",
  "How would you describe this for customers?":
    "How would you describe this for customers?",
  "Aim for 25 characters or fewer so the label fits on one line.":
    "Aim for 25 characters or fewer so the label fits on one line.",
  "Over 25 characters — the label may wrap on desktop. Consider trimming.":
    "Over 25 characters — the label may wrap on desktop. Consider trimming.",
  "Over 40 characters — the label will wrap on every screen. Trim it down.":
    "Over 40 characters — the label will wrap on every screen. Trim it down.",
  Description: "Description",
  "Amenity added to your library.": "Amenity added to your library.",
  "Could not add amenity. Please try again.":
    "Could not add amenity. Please try again.",
  "Amenity updated.": "Amenity updated.",
  "Could not update amenity. Please try again.":
    "Could not update amenity. Please try again.",
  "No icons match your search.": "No icons match your search.",
  "Don't see what you need?": "Don't see what you need?",
  "Add to your library.": "Add to your library.",
  added: "added",
  "Amenity attached.": "Amenity attached.",
  "Could not attach. Please try again.": "Could not attach. Please try again.",
  "Your amenity library is empty. Add one to get started.":
    "Your amenity library is empty. Add one to get started.",
  "Add to your library": "Add to your library",
  "Build your amenity library": "Build your amenity library",
  "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.":
    "Pick amenities from our catalog and describe each one. Drag to reorder — customers see them in this order on every space and location.",
  "Pick from our icon catalog and describe each amenity in your own words.":
    "Pick from our icon catalog and describe each amenity in your own words.",
  "This change is visible to guests immediately.":
    "This change is visible to guests immediately.",
  "Could not save the new order.": "Could not save the new order.",
  "Amenity removed.": "Amenity removed.",
  "Could not remove. Please try again.": "Could not remove. Please try again.",
  "Could not detach amenity (missing identifier).":
    "Could not detach amenity (missing identifier).",
  "Could not detach.": "Could not detach.",
  "Could not detach amenity.": "Could not detach amenity.",
  "No location amenities added yet.": "No location amenities added yet.",
  Catalogs: "Catalogs",
  Catalog: "Catalog",
  "No catalogs yet": "No catalogs yet",
  "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.":
    "Your catalogs will appear here once they're set up. To add one, email help@flexspace.ai.",
  "1 offering": "1 offering",
  "Catalog not found": "Catalog not found",
  "This catalog isn't available. It may have been renamed or removed.":
    "This catalog isn't available. It may have been renamed or removed.",
  "Back to Catalogs": "Back to Catalogs",
  "Your profile": "Your profile",
  "Follow us on LinkedIn": "Síguenos en LinkedIn",
  Partner: "Partner",
  "Account type": "Account type",
  "White-label": "White-label",
  Teams: "Teams",
  "1 location": "1 location",
  "Sign out": "Sign out",
  "Your account": "Your account",
  Cancel: "Cancelar",
  Edit: "Editar",
  "Save changes": "Guardar cambios",
  "Profile updated.": "Perfil actualizado.",
  "Your full name": "Tu nombre completo",
  "Please enter your name.": "Introduce tu nombre.",
  "Couldn't save your changes. Please try again.":
    "No se pudieron guardar los cambios. Inténtalo de nuevo.",
  "Unavailable on {days} — the add-on will skip that day.":
    "No disponible el {days} — el complemento omitirá ese día.",
  "Unavailable on {days} — the add-on will skip those days.":
    "No disponible los días {days} — el complemento omitirá esos días.",
  "Removed {addOns} — no longer available for your booking.":
    "Se eliminó {addOns}: ya no está disponible para tu reserva.",
  "Removed {addOns} — sold out for your booking.":
    "Se eliminó {addOns}: agotado para tu reserva.",
  "Removed {addOns} — sold out on {date}.":
    "Se eliminó {addOns}: agotado el {date}.",
  "Removed {addOns} — sold out for a party of {guests} on {date}.":
    "Se eliminó {addOns}: agotado para un grupo de {guests} el {date}.",
  "Fully booked on {days} — the add-on will skip that day.":
    "Completo el {days} — el complemento omitirá ese día.",
  "Fully booked on {days} — the add-on will skip those days.":
    "Completo los días {days} — el complemento omitirá esos días.",
  "Only {count} left": "Solo quedan {count}",
  Team: "Equipo",
  Role: "Rol",
  Admin: "Administrador",
  Standard: "Estándar",
  Actions: "Acciones",
  "Add user": "Añadir usuario",
  "Remove user": "Eliminar usuario",
  Member: "Miembro",
  member: "miembro",
  members: "miembros",
  admin: "administrador",
  admins: "administradores",
  "Team actions for {member}": "Acciones de equipo para {member}",
  "(you)": "(tú)",
  "{email} · (you)": "{email} · (tú)",
  "Reset password": "Restablecer contraseña",
  "Send invite": "Enviar invitación",
  "Send reset email": "Enviar correo de restablecimiento",
  "Sending…": "Enviando…",
  "Try again": "Inténtalo de nuevo",
  "We couldn't load our payment provider":
    "No pudimos cargar nuestro proveedor de pagos",
  "An ad blocker, privacy extension, or restricted network can block it. Allow this page, or try a different browser.":
    "Un bloqueador de anuncios, una extensión de privacidad o una red restringida pueden bloquearlo. Permite esta página o prueba con otro navegador.",
  "If the payment form doesn't appear, close this window and start your booking again.":
    "Si el formulario de pago no aparece, cierra esta ventana y vuelve a comenzar tu reserva.",
  "Please add their name.": "Por favor, añade su nombre.",
  "Please add a valid email.": "Por favor, añade un correo válido.",
  "Invite sent to {email}": "Invitación enviada a {email}",
  "Role updated.": "Rol actualizado.",
  "User removed.": "Usuario eliminado.",
  "Password reset email sent.":
    "Correo de restablecimiento de contraseña enviado.",
  "Something went wrong. Please try again.":
    "Algo salió mal. Inténtalo de nuevo.",
  "Remove {name}": "Eliminar {name}",
  "{count} {name}": "{count} {name}",
  "Remove {name}?": "¿Eliminar a {name}?",
  "Remove this user?": "¿Eliminar a este usuario?",
  "This removes their access to this dashboard. Their account is kept and they can be re-added later.":
    "Esto elimina su acceso a este panel. Su cuenta se conserva y se puede volver a añadir más adelante.",
  "You're removing yourself — you'll lose access immediately.":
    "Te estás eliminando a ti mismo: perderás el acceso inmediatamente.",
  "Send a password reset email to {email}?":
    "¿Enviar un correo de restablecimiento de contraseña a {email}?",
  "Change role to Admin": "Cambiar rol a Administrador",
  "Change role to Standard": "Cambiar rol a Estándar",
  "Send password reset": "Enviar restablecimiento de contraseña",
  "Full dashboard access, except the Settings section.":
    "Acceso completo al panel, excepto la sección Configuración.",
  "Everything a standard user can do, plus Settings — notifications and team management.":
    "Todo lo que puede hacer un usuario estándar, además de Configuración: notificaciones y gestión del equipo.",
  "They'll receive an email invitation to set their password.":
    "Recibirán una invitación por correo para establecer su contraseña.",
  "Manage who can access the {partnerName} dashboard.":
    "Gestiona quién puede acceder al panel de {partnerName}.",
  "No team members yet": "Aún no hay miembros del equipo",
  "Add a team member to give them access to this dashboard.":
    "Añade un miembro del equipo para darle acceso a este panel.",
  Settings: "Configuración",
  "You don't have access to the catalog": "No tienes acceso al catálogo",
  "Ask one of your admins to grant you catalog access.":
    "Pide a uno de tus administradores que te dé acceso al catálogo.",
  Orders: "Pedidos",
  Campaigns: "Campañas",
  "Create orders": "Crear pedidos",
  "Cancel orders and refund": "Cancelar pedidos y reembolsar",
  "Accept or reject requests": "Aceptar o rechazar solicitudes",
  "Open and edit the catalog": "Abrir y editar el catálogo",
  "Activate and deactivate products": "Activar y desactivar productos",
  "Create and edit campaigns": "Crear y editar campañas",
  "Book on behalf of a customer.": "Reservar en nombre de un cliente.",
  "Cancel an order or a booking and issue refunds.":
    "Cancelar un pedido o una reserva y emitir reembolsos.",
  "Decide requested orders and membership requests.":
    "Decidir sobre pedidos solicitados y solicitudes de membresía.",
  "See and change spaces, pricing, layouts, images and FAQ.":
    "Ver y cambiar espacios, precios, distribuciones, imágenes y preguntas frecuentes.",
  "Turn a space or membership on or off for booking.":
    "Activar o desactivar un espacio o una membresía para reservas.",
  "Make, edit, archive and label promotions.":
    "Crear, editar, archivar y etiquetar promociones.",
  "Edit permissions": "Editar permisos",
  "What {name} can do in this dashboard.":
    "Lo que {name} puede hacer en este panel.",
  "Save permissions": "Guardar permisos",
  Access: "Acceso",
  "Full access": "Acceso total",
  "All permissions": "Todos los permisos",
  "{held} of {total} permissions": "{held} de {total} permisos",
  Permissions: "Permisos",
  "They start with everything. Uncheck what they shouldn't do.":
    "Empiezan con todo. Desmarca lo que no deberían poder hacer.",
  "Permissions saved.": "Permisos guardados.",
  Owner: "Propietario",
  owner: "propietario",
  owners: "propietarios",
  "Change role to Owner": "Cambiar rol a Propietario",
  "Owners have full access. Change the role to limit it.":
    "Los propietarios tienen acceso total. Cambia el rol para limitarlo.",
  "Everything an admin can do, always with every permission. Only an owner can add or change owners.":
    "Todo lo que puede hacer un administrador, siempre con todos los permisos. Solo un propietario puede añadir o cambiar propietarios.",
  "You can only grant permissions you hold.":
    "Solo puedes otorgar los permisos que tienes.",
  "Admin access required": "Se requiere acceso de administrador",
  "You need an admin role to manage this team. Ask one of your admins to update your role.":
    "Necesitas un rol de administrador para gestionar este equipo. Pide a uno de tus administradores que actualice tu rol.",
  "You need an admin role to view this page. Ask one of your admins to update your role.":
    "Necesitas un rol de administrador para ver esta página. Pide a uno de tus administradores que actualice tu rol.",
  "We couldn't load these rooms.": "No pudimos cargar estas salas.",
  "We couldn't load your team. Check your connection and try again.":
    "No pudimos cargar tu equipo. Comprueba tu conexión e inténtalo de nuevo.",
  "Updating…": "Actualizando…",
  "A booking made inside this window gets its reminder as soon as it's confirmed.":
    "Una reserva hecha dentro de esta ventana recibe el recordatorio en cuanto se confirma.",
  "A nudge before the reservation starts. Because it's built at send time, anything time-sensitive you put here — an access code, say — is always the version you last saved.":
    "Un aviso antes de que empiece la reserva. Como se genera al momento del envío, cualquier dato sensible al tiempo que pongas aquí — un código de acceso, por ejemplo — es siempre la última versión que guardaste.",
  "Add product type": "Añadir tipo de producto",
  "Add teammate": "Añadir compañero",
  "All changes saved": "Todos los cambios guardados",
  "All locations": "Todas las ubicaciones",
  "All notifications": "Todas las notificaciones",
  "Also send a copy to your team": "Envía también una copia a tu equipo",
  "An invitation to buy another multi-pass, sent when a customer runs out. Turn it off if you run your own re-engagement emails — from HubSpot, for example.":
    "Una invitación a comprar otro multipase, enviada cuando al cliente se le acaba. Desactívala si envías tus propios correos de reactivación — desde HubSpot, por ejemplo.",
  "Applies to": "Se aplica a",
  "Automated emails Flexspace sends your customers. Open one to change what it says, when it goes out, or turn it off.":
    "Correos automáticos que Flexspace envía a tus clientes. Abre uno para cambiar lo que dice, cuándo se envía o desactivarlo.",
  "Before the booking starts": "Antes de que empiece la reserva",
  "Booking reminder": "Recordatorio de reserva",
  "Booking reminder saved.": "Recordatorio de reserva guardado.",
  CC: "CC",
  Custom: "Personalizado",
  Default: "Predeterminado",
  "Every booking": "Todas las reservas",
  "Every confirmed booking gets this reminder.":
    "Todas las reservas confirmadas reciben este recordatorio.",
  "Flexspace writes and sends this email — the exact copy is shown in the preview. Editing the wording here is coming; for now you can turn it off or CC your team.":
    "Flexspace redacta y envía este correo — el texto exacto se muestra en la vista previa. Pronto podrás editar el texto aquí; por ahora puedes desactivarlo o poner a tu equipo en copia.",
  Insert: "Insertar",
  "Leave this on your default and it follows every change you make there. A space here can still send its own on top.":
    "Si lo dejas en tu versión predeterminada, seguirá cada cambio que hagas allí. Un espacio de aquí aún puede enviar la suya propia.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, 9:00 AM.":
    "Los campos dinámicos se muestran rellenos con una reserva de ejemplo: Priya Raman, Studio 2 en Mission Bay, 9:00 AM.",
  "Mission Bay": "Mission Bay",
  "Multi Day Pass 5 Pack": "Multi Day Pass 5 Pack",
  "Multi-pass top-up": "Recarga de multipase",
  "Multi-pass top-up saved.": "Recarga de multipase guardada.",
  "No one CC'd": "Nadie en copia",
  "No product types match": "Ningún tipo de producto coincide con",
  "No reminder goes out until you set one up.":
    "No se envía ningún recordatorio hasta que configures uno.",
  "Not set": "Sin configurar",
  Notifications: "Notificaciones",
  Off: "Desactivado",
  "Off sends nothing here, whatever the levels above say.":
    "Desactivado no envía nada aquí, sea lo que digan los niveles superiores.",
  "Off stops the reminder everywhere.":
    "Desactivado detiene el recordatorio en todas partes.",
  On: "Activado",
  "Only bookings of certain product types":
    "Solo reservas de ciertos tipos de producto",
  "Only bookings of the selected product types get this reminder.":
    "Solo las reservas de los tipos de producto seleccionados reciben este recordatorio.",
  Override: "Personalizar",
  "Payment failed": "Pago fallido",
  'Pick at least one product type, or switch back to "Every booking".':
    'Elige al menos un tipo de producto o vuelve a "Todas las reservas".',
  Preview: "Vista previa",
  "Rebuilt at send time — edits reach every future email":
    "Se genera al enviarse — los cambios llegan a todos los correos futuros",
  Reminder: "Recordatorio",
  "Reminder email": "Correo de recordatorio",
  "Reminder reset — this level inherits again.":
    "Recordatorio restablecido: este nivel vuelve a heredar.",
  "Reminders cascade: your default applies everywhere. A location can send its own, and a space can send its own on top of that.":
    "Los recordatorios se heredan: tu versión predeterminada se aplica en todas partes. Una ubicación puede enviar la suya, y un espacio la suya por encima.",
  "Remove override": "Eliminar personalización",
  "Reset to defaults": "Restablecer a los predeterminados",
  "Sample booking": "Reserva de ejemplo",
  "Save reminder": "Guardar recordatorio",
  "Search locations": "Buscar ubicaciones",
  "Search product types…": "Buscar tipos de producto…",
  "Search spaces": "Buscar espacios",
  "See reminder": "Ver recordatorio",
  "Sends its own version — every space here inherits it.":
    "Envía su propia versión: todos los espacios de aquí la heredan.",
  "Sent the moment the last pass in a bundle is used — timing can't be changed.":
    "Se envía en cuanto se usa el último pase del paquete — el momento no se puede cambiar.",
  "Set up reminder": "Configurar recordatorio",
  "Shown with a sample customer and pass. The wording is what actually goes out; the button and photo take your own branding.":
    "Se muestra con un cliente y un pase de ejemplo. El texto es el que realmente se envía; el botón y la foto llevan tu propia marca.",
  Space: "Espacio",
  "Spaces at": "Espacios en",
  Subject: "Asunto",
  "The reminder bookings of this space get, inheriting from its location.":
    "El recordatorio que reciben las reservas de este espacio, heredado de su ubicación.",
  "The reminder every booking at this location gets, inheriting from your default.":
    "El recordatorio que recibe cada reserva de esta ubicación, heredado de tu versión predeterminada.",
  "The reminder every booking gets before it starts, unless a location or a space sends its own.":
    "El recordatorio que recibe cada reserva antes de comenzar, salvo que una ubicación o un espacio envíe el suyo.",
  "They're CC'd on every copy of this email that goes out.":
    "Reciben copia de cada envío de este correo.",
  "This email is off, so nobody is receiving it. Your settings are saved and will apply if you turn it back on.":
    "Este correo está desactivado, así que nadie lo recibe. Tu configuración está guardada y se aplicará si lo vuelves a activar.",
  "This is the most specific level: a reminder set here wins over its location and your default.":
    "Este es el nivel más específico: un recordatorio configurado aquí prevalece sobre su ubicación y tu versión predeterminada.",
  "This location": "Esta ubicación",
  "This space": "Este espacio",
  To: "Para",
  "Turn this email on or off": "Activa o desactiva este correo",
  "Turn this reminder on or off": "Activar o desactivar este recordatorio",
  "Unsaved changes": "Cambios sin guardar",
  Using: "Usa",
  "Using default": "Usa la predeterminada",
  "Using your default — every space here inherits it.":
    "Usa tu versión predeterminada: todos los espacios de aquí la heredan.",
  "We couldn't load your booking reminder. Check your connection and try again.":
    "No pudimos cargar tu recordatorio de reserva. Comprueba tu conexión e inténtalo de nuevo.",
  "We couldn't reset this reminder. Try again.":
    "No pudimos restablecer este recordatorio. Inténtalo de nuevo.",
  "We couldn't save this reminder. Try again.":
    "No pudimos guardar este recordatorio. Inténtalo de nuevo.",
  "What your customers get": "Lo que reciben tus clientes",
  "When a customer uses their last day pass":
    "Cuando un cliente usa su último pase diario",
  "When it sends": "Cuándo se envía",
  "Yours to configure": "Configurables por ti",
  custom: "personalizados",
  "custom version": "versión personalizada",
  "custom versions": "versiones personalizadas",
  "hours before the booking starts": "horas antes de que empiece la reserva",
  location: "ubicación",
  of: "de",
  "reminder settings": "configuración del recordatorio",
  space: "espacio",
  spaces: "espacios",
  "your default": "tu versión predeterminada",
  "Space layouts": "Distribuciones del espacio",
  "See all space layouts": "Ver todas las distribuciones",
  "All space layouts": "Todas las distribuciones del espacio",
  Layout: "Distribución",
  "Select layout": "Selecciona distribución",
  "Number of people": "Número de personas",
  "Our meeting rooms fit up to {max} people.":
    "Nuestras salas de reuniones admiten hasta {max} personas.",

  // Staff order confirmation email (Settings -> Notifications)
  "Staff order confirmation": "Confirmación de pedido para el personal",
  "When an order is confirmed": "Cuando se confirma un pedido",
  "Who on your team hears about a confirmed order, and what they read. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "Quién de tu equipo se entera de un pedido confirmado y qué lee. Configúralo una vez para todo y deja que una ubicación, un tipo de producto o un espacio concreto se diferencie donde haga falta.",
  "Who on your team hears about a confirmed order, and what they read. These apply to every location and space unless a more specific level sets its own.":
    "Quién de tu equipo se entera de un pedido confirmado y qué lee. Se aplica a todas las ubicaciones y espacios salvo que un nivel más específico defina el suyo.",
  "This email cascades: your defaults apply everywhere. A location can set its own, a product type at that location can set its own, and a single space can set its own on top of that.":
    "Este correo se hereda en cascada: tus valores predeterminados se aplican en todas partes. Una ubicación puede definir los suyos, un tipo de producto en esa ubicación puede definir los suyos y un espacio concreto puede definir los suyos por encima.",
  "The staff email for every order at this location, inheriting from your defaults.":
    "El correo para el personal de cada pedido en esta ubicación, heredado de tus valores predeterminados.",
  "Anything left on its default here follows your defaults. A product type or a single space at":
    "Todo lo que quede en su valor predeterminado aquí sigue tus valores predeterminados. Un tipo de producto o un espacio concreto en",
  "can still set its own on top.": "aún puede definir el suyo por encima.",
  "Orders of this product type at this location only, inheriting from the location and your defaults.":
    "Solo los pedidos de este tipo de producto en esta ubicación, heredando de la ubicación y de tus valores predeterminados.",
  "Anything custom here wins over":
    "Todo lo personalizado aquí prevalece sobre",
  "and your defaults. A single space can still set its own on top.":
    "y tus valores predeterminados. Un espacio concreto aún puede definir el suyo por encima.",
  "This space only, inheriting from everything above it.":
    "Solo este espacio, heredando de todo lo que está por encima.",
  "This is the most specific level: anything custom here wins over every other level.":
    "Este es el nivel más específico: todo lo personalizado aquí prevalece sobre cualquier otro nivel.",
  Recipients: "Destinatarios",
  Sender: "Remitente",
  "Staff instructions": "Instrucciones para el personal",
  "Applies to every order unless a more specific level sets its own list. Overriding replaces every recipient — lists don't merge across levels.":
    "Se aplica a todos los pedidos salvo que un nivel más específico defina su propia lista. Al anular se sustituyen todos los destinatarios: las listas no se combinan entre niveles.",
  "Overriding replaces the inherited list in full — lists don't merge across levels.":
    "Al anular se sustituye por completo la lista heredada: las listas no se combinan entre niveles.",
  "We couldn't load this email's settings. Check your connection and try again.":
    "No pudimos cargar la configuración de este correo. Comprueba tu conexión e inténtalo de nuevo.",
  "Only an admin can change this email. You can look up any level here.":
    "Solo un administrador puede cambiar este correo. Aquí puedes consultar cualquier nivel.",
  Defaults: "Predeterminados",
  "Product type": "Tipo de producto",
  "Product types at": "Tipos de producto en",
  "Spaces using this product type": "Espacios que usan este tipo de producto",
  "Sits between the location and a single space. A meeting room and a day pass at the same address rarely need the same people notified.":
    "Se sitúa entre la ubicación y un espacio concreto. Una sala de reuniones y un pase de día en la misma dirección rara vez necesitan avisar a las mismas personas.",
  "No product type": "Sin tipo de producto",
  "No one": "Nadie",
  "no one": "nadie",
  Open: "Abrir",
  "Reset all to defaults": "Restablecer todo a los valores predeterminados",
  "Reset to": "Restablecer a",
  "reset to defaults.": "restablecido a los valores predeterminados.",
  "Couldn't reset this level. Please try again.":
    "No se pudo restablecer este nivel. Inténtalo de nuevo.",
  "Actions for": "Acciones para",
  "Using default · from": "Usa el valor predeterminado · de",
  "saved.": "guardado.",
  "Sent to": "Enviado a",
  "Everyone here is on the To line. At least one is required.":
    "Todos los que aparecen aquí van en el campo Para. Se requiere al menos uno.",
  "Reply-to": "Responder a",
  "Where a reply lands. Optional — leave it empty and replies go to the From address.":
    "Dónde llega una respuesta. Opcional: si lo dejas vacío, las respuestas van a la dirección del remitente.",
  "From name": "Nombre del remitente",
  "The name your team sees in their inbox.":
    "El nombre que tu equipo ve en su bandeja de entrada.",
  "Merge fields are filled in when the order is confirmed.":
    "Los campos combinados se rellenan cuando se confirma el pedido.",
  Title: "Título",
  "The heading inside the email.": "El encabezado dentro del correo.",
  "Note to your team": "Nota para tu equipo",
  "Rebuilt at send time, so a change reaches every future order.":
    "Se genera en el momento del envío, así que un cambio llega a todos los pedidos futuros.",
  Attachment: "Adjunto",
  "One PDF, sent with every copy of this email.":
    "Un PDF, enviado con cada copia de este correo.",
  "Upload PDF": "Subir PDF",
  Replace: "Sustituir",
  "Uploading…": "Subiendo…",
  "Add recipient": "Añadir destinatario",
  "Add reply-to": "Añadir responder a",
  "Add reply-to address": "Añadir dirección de respuesta",
  "Add 1 recipient": "Añadir 1 destinatario",
  recipient: "destinatario",
  recipients: "destinatarios",
  override: "anulación",
  overrides: "anulaciones",
  "Add a recipient to continue.": "Añade un destinatario para continuar.",
  "At least one recipient is required, or reset this level so it falls back to":
    "Se requiere al menos un destinatario, o restablece este nivel para que vuelva a",
  "At least one recipient is required — nothing sends without one.":
    "Se requiere al menos un destinatario: sin uno no se envía nada.",
  "Anyone here receives the full order details, including the guest's name and email.":
    "Cualquiera que esté aquí recibe todos los datos del pedido, incluidos el nombre y el correo del huésped.",
  "Your team": "Tu equipo",
  "Already added": "Ya añadido",
  "Someone else": "Otra persona",
  Address: "Dirección",
  "is not a valid email address.": "no es una dirección de correo válida.",
  "is already on the list.": "ya está en la lista.",
  "Send test email": "Enviar correo de prueba",
  "Send test": "Enviar prueba",
  "Send to": "Enviar a",
  "What will send": "Qué se enviará",
  "We'll send one copy of the": "Enviaremos una copia de la versión de",
  "version, filled in with a sample order. Your real recipients are not contacted.":
    ", rellenada con un pedido de ejemplo. No se contacta a tus destinatarios reales.",
  "Test sent to": "Prueba enviada a",
  "Couldn't send the test. Please try again.":
    "No se pudo enviar la prueba. Inténtalo de nuevo.",
  "your defaults": "tus valores predeterminados",
  "reset — this level inherits again.":
    "restablecido: este nivel vuelve a heredar.",
  "Staff email": "Correo del personal",
  "See recipients": "Ver destinatarios",
  "can still set its own on top — a meeting room and a day pass at the same address rarely need the same people notified.":
    "aún puede definir el suyo por encima: una sala de reuniones y un pase de día en la misma dirección rara vez necesitan avisar a las mismas personas.",
  "Search product types": "Buscar tipos de producto",
  "product type": "tipo de producto",
  "Set up": "Configurar",
  "Using defaults": "Usa los valores predeterminados",
  "Staff order confirmation saved.":
    "Confirmación de pedido para el personal guardada.",
  "This product type": "Este tipo de producto",
  "No one is notified until you name someone.":
    "No se avisa a nadie hasta que indiques a alguien.",
  "Merge fields are shown filled in with a sample order: Priya Raman, Studio 2 at Mission Bay, July 30.":
    "Los campos combinados se muestran rellenados con un pedido de ejemplo: Priya Raman, Studio 2 en Mission Bay, 30 de julio.",
  "One step more specific than this location: applies to orders of that type here, and a single space can still override it.":
    "Un nivel más específico que esta ubicación: se aplica a los pedidos de ese tipo aquí, y un espacio concreto aún puede anularlo.",
  "The most specific level: a space overrides its product type and this location.":
    "El nivel más específico: un espacio prevalece sobre su tipo de producto y sobre esta ubicación.",
  "The most specific level: a space overrides this product type and its location.":
    "El nivel más específico: un espacio prevalece sobre este tipo de producto y sobre su ubicación.",
  "This booking link looks incomplete":
    "Este enlace de reserva parece incompleto",
  "Some email apps shorten long links. Please open the link from your confirmation email again, or contact the venue if it keeps happening.":
    "Algunas aplicaciones de correo acortan los enlaces largos. Abre de nuevo el enlace desde tu correo de confirmación o contacta con el espacio si el problema continúa.",
  "Guest order confirmation": "Confirmación de pedido para el cliente",
  "When a customer books": "Cuando un cliente reserva",
  "The confirmation every customer gets when they book — the welcome note, directions and help section. Set it once for everywhere, then let a location, a product type or a single space differ where it needs to.":
    "La confirmación que recibe cada cliente al reservar: la nota de bienvenida, las indicaciones y la sección de ayuda. Defínela una vez para todas partes y deja que una ubicación, un tipo de producto o un espacio concreto difieran donde haga falta.",
  "What your customers read when a booking is confirmed — the subject, the welcome note, directions and help section. These apply everywhere unless a more specific level sets its own. Every confirmed booking sends one: this email can't be turned off.":
    "Lo que leen tus clientes cuando se confirma una reserva: el asunto, la nota de bienvenida, las indicaciones y la sección de ayuda. Se aplican en todas partes salvo que un nivel más específico establezca los suyos. Cada reserva confirmada envía uno: este correo no se puede desactivar.",
  "The booking confirmation for every order at this location, inheriting from your defaults.":
    "La confirmación de reserva para cada pedido en esta ubicación, heredando de tus valores predeterminados.",
  "Anything left on its default here follows your defaults. What you set here also backs this location's add-on and invite confirmation emails. A product type or a single space at":
    "Todo lo que quede aquí en su valor predeterminado sigue tus valores predeterminados. Lo que definas aquí también respalda los correos de confirmación de complementos e invitaciones de esta ubicación. Un tipo de producto o un espacio concreto en",
  "Bookings of this product type at this location only, inheriting from the location and your defaults.":
    "Solo las reservas de este tipo de producto en esta ubicación, heredando de la ubicación y de tus valores predeterminados.",
  "Customer email": "Correo del cliente",
  "See what sends": "Ver qué se envía",
  "Guest order confirmation saved.":
    "Confirmación de pedido para el cliente guardada.",
  "Subject & title": "Asunto y título",
  "Email content": "Contenido del correo",
  "Reply-to & attachment": "Responder a y adjunto",
  "The subject and title can carry:": "El asunto y el título pueden incluir:",
  "Each section falls back to our standard copy when left empty — the preview shows exactly what sends.":
    "Cada sección vuelve a nuestro texto estándar cuando se deja vacía; la vista previa muestra exactamente lo que se envía.",
  "Our standard subject": "Nuestro asunto estándar",
  "welcome note": "nota de bienvenida",
  directions: "indicaciones",
  "help section": "sección de ayuda",
  "Every section sends our standard copy.":
    "Todas las secciones envían nuestro texto estándar.",
  "Custom copy:": "Texto personalizado:",
  "Welcome note": "Nota de bienvenida",
  "Help section": "Sección de ayuda",
  "Merge fields fill in when the booking is confirmed. Empty sends our standard subject.":
    "Los campos combinados se rellenan cuando se confirma la reserva. Si lo dejas vacío, se envía nuestro asunto estándar.",
  "The headline inside the email. Empty sends our standard headline.":
    "El titular dentro del correo. Si lo dejas vacío, se envía nuestro titular estándar.",
  "Opens the email, above the booking details. Empty sends our standard thank-you.":
    "Abre el correo, encima de los detalles de la reserva. Si lo dejas vacío, se envía nuestro agradecimiento estándar.",
  "Under the email's Directions heading, next to the map link. Empty sends the location's address line.":
    "Bajo el encabezado de indicaciones del correo, junto al enlace del mapa. Si lo dejas vacío, se envía la dirección de la ubicación.",
  "Closes the email. The booking's cancellation policy always sends beneath it, so there is no need to insert it. Empty sends our standard invitation to reply.":
    "Cierra el correo. La política de cancelación de la reserva siempre se envía debajo, así que no hace falta insertarla. Si lo dejas vacío, se envía nuestra invitación estándar a responder.",
  "Where a customer's reply lands. Empty sends replies to the From address.":
    "Adónde llega la respuesta del cliente. Si lo dejas vacío, las respuestas van a la dirección del remitente.",
  "The name customers see in their inbox.":
    "El nombre que los clientes ven en su bandeja de entrada.",
  "One PDF, sent with every confirmation.":
    "Un PDF, enviado con cada confirmación.",
  "Opening hours": "Horario de apertura",
  "The location's opening hours are listed here.":
    "Aquí se muestran los horarios de apertura de la ubicación.",
  "Our standard help copy: an invitation to reply to this email.":
    "Nuestro texto de ayuda estándar: una invitación a responder a este correo.",
  "This booking's cancellation policy is stated here. It is worked out per booking when the email sends, so it can't be edited.":
    "Aquí se indica la política de cancelación de esta reserva. Se calcula para cada reserva al enviar el correo, por lo que no se puede editar.",
  "Merge fields are shown filled in with a sample booking: Priya Raman, Studio 2 at Mission Bay, July 30. The preview shows what actually sends — including inherited and standard copy you haven't overridden.":
    "Los campos combinados se muestran rellenados con una reserva de ejemplo: Priya Raman, Studio 2 en Mission Bay, 30 de julio. La vista previa muestra lo que realmente se envía, incluido el texto heredado y estándar que no has sobrescrito.",
  "If a product type or space overrides this copy for that booking, the email shows the version that actually sent.":
    "Si un tipo de producto o un espacio sobrescribe este texto para esa reserva, el correo muestra la versión que realmente se envió.",
  "We'll re-send the confirmation from one of your recent bookings — the real email, exactly as that customer received it. It carries that booking's real details, so send it somewhere you'd be comfortable those details going.":
    "Reenviaremos la confirmación de una de tus reservas recientes: el correo real, exactamente como lo recibió ese cliente. Incluye los datos reales de esa reserva, así que envíalo a un destino donde no te importe que lleguen.",
  "only the address above": "solo la dirección de arriba",
  // Recurring bookings — the storefront Repeat control
  "These dates are no longer available: {dates}. Choose another time, or turn Repeat off.":
    "Estas fechas ya no están disponibles: {dates}. Elige otra hora o desactiva la repetición.",
  "Every {weekday}": "Cada {weekday}",
  "Every {interval} weeks on {weekday}":
    "Cada {interval} semanas, los {weekday}",
  "{span} · {count} bookings": "{span} · {count} reservas",
  "Your bookings": "Tus reservas",
  "{date} fell on your pattern but was already taken. It was left out of the recurring booking and was not charged.":
    "{date} coincidía con tu patrón pero ya estaba ocupada. Se excluyó de la reserva recurrente y no se cobró.",
  "{dates} fell on your pattern but were already taken. They were left out of the recurring booking and were not charged.":
    "{dates} coincidían con tu patrón pero ya estaban ocupadas. Se excluyeron de la reserva recurrente y no se cobraron.",
  "Thank you for booking with us. A confirmation email covering all {count} bookings has been sent to {email}. We are looking forward to seeing you soon.":
    "Gracias por reservar con nosotros. Se ha enviado a {email} un correo de confirmación que cubre las {count} reservas. Esperamos verte pronto.",
  "Not refundable. A single date can be cancelled to free the room, but is not refunded.":
    "No reembolsable. Una fecha puede cancelarse para liberar la sala, pero no se reembolsa.",
  "Refundable in full until {deadline}. After that, a single date can be cancelled to free the room, but is not refunded.":
    "Reembolsable por completo hasta el {deadline}. Después, una fecha puede cancelarse para liberar la sala, pero no se reembolsa.",
  "Charged once for the whole recurring booking.":
    "Se cobra una sola vez por toda la reserva recurrente.",
  "Choose a date and time to repeat this booking.":
    "Elige una fecha y hora para repetir esta reserva.",
  "Choose a date to repeat this booking.":
    "Elige una fecha para repetir esta reserva.",
  "Repeat this booking": "Repetir esta reserva",
  "Same room and time, every week": "Misma sala y hora, cada semana",
  "Same room and time, every {weekday}": "Misma sala y hora, cada {weekday}",
  Weekly: "Semanal",
  "Every 2 weeks": "Cada 2 semanas",
  "Every 3 weeks": "Cada 3 semanas",
  "Every 4 weeks": "Cada 4 semanas",
  "location closed": "ubicación cerrada",
  "already booked": "ya reservado",
  "too soon to book": "demasiado pronto para reservar",
  "too short for this room": "demasiado corto para esta sala",
  unavailable: "no disponible",
  Unavailable: "No disponible",
  "{count} booking": "{count} reserva",
  "{count} bookings": "{count} reservas",
  "Shortened to {count} bookings — a recurring booking has to finish inside the booking window, which ends {date}.":
    "Reducido a {count} reservas: una reserva recurrente debe terminar dentro del período de reserva, que finaliza el {date}.",
  "{count} bookings · {first} – {last}": "{count} reservas · {first} – {last}",
  "Prices confirmed on Save": "Precios confirmados al guardar",
  "{count} unavailable date skipped · prices confirmed on Save":
    "{count} fecha no disponible omitida · precios confirmados al guardar",
  "{count} unavailable dates skipped · prices confirmed on Save":
    "{count} fechas no disponibles omitidas · precios confirmados al guardar",
  "Repeats {preset} · {count} bookings through {last}":
    "Se repite {preset} · {count} reservas hasta el {last}",
  "{first} through {last}": "Del {first} al {last}",
  "Every date on this pattern is available.":
    "Todas las fechas de este patrón están disponibles.",
  "1 date on this pattern is unavailable and not charged: {list}.":
    "1 fecha de este patrón no está disponible y no se cobra: {list}.",
  "{count} dates on this pattern are unavailable and not charged: {list}.":
    "{count} fechas de este patrón no están disponibles y no se cobran: {list}.",
  "Your recurring booking": "Tu reserva recurrente",
  // Manage-order page — the customer's own view of a booking
  "This booking could not be loaded. Please try again, or contact the venue.":
    "No se pudo cargar esta reserva. Inténtalo de nuevo o contacta con el espacio.",
  "1 guest": "1 invitado",
  "{count} guests": "{count} invitados",
  "This date could not be cancelled.": "No se pudo cancelar esta fecha.",
  "The booking could not be cancelled.": "No se pudo cancelar la reserva.",
  "This page is for recurring bookings. Your booking is on its confirmation page.":
    "Esta página es para reservas recurrentes. Tu reserva está en su página de confirmación.",
  "Open confirmation page": "Abrir la página de confirmación",
  "Cancelled on {date}, before the first booking. Every one of the {count} dates was cancelled and {refund} was refunded to your payment method.":
    "Cancelada el {date}, antes de la primera reserva. Cada una de las {count} fechas fue cancelada y se reembolsaron {refund} a tu método de pago.",
  "1 booking cancelled": "1 reserva cancelada",
  "Confirmation {code}": "Confirmación {code}",
  "Booked {date}": "Reservado el {date}",
  "Next booking": "Próxima reserva",
  "Your booking": "Tu reserva",
  "Cancelled recurring booking": "Reserva recurrente cancelada",
  "Cancelled booking": "Reserva cancelada",
  "No bookings left": "No quedan reservas",
  "{completed} of {total} bookings completed":
    "{completed} de {total} reservas completadas",
  "{done} · booking {next} is next":
    "{done} · la reserva {next} es la siguiente",
  "Add recurring booking to calendar":
    "Añadir la reserva recurrente al calendario",
  "Add to calendar": "Añadir al calendario",
  "Get directions": "Cómo llegar",
  "Book this again": "Reservar esto de nuevo",
  "Book this room again": "Reservar esta sala de nuevo",
  "This recurring booking was cancelled":
    "Esta reserva recurrente fue cancelada",
  "This booking was cancelled": "Esta reserva fue cancelada",
  "Cancelled on {date}. {refund} was refunded to your payment method.":
    "Cancelada el {date}. Se reembolsaron {refund} a tu método de pago.",
  "Cancelled on {date}. No refund was issued.":
    "Cancelada el {date}. No se emitió ningún reembolso.",
  Schedule: "Calendario",
  "{count} bookings cancelled": "{count} reservas canceladas",
  "{completed} completed · {cancelled} cancelled · {upcoming} upcoming":
    "{completed} completadas · {cancelled} canceladas · {upcoming} próximas",
  Upcoming: "Próxima",
  Completed: "Completada",
  Cancelled: "Cancelada",
  "Cancel this date?": "¿Cancelar esta fecha?",
  "{date} will be freed for someone else, and the rest of your recurring booking stays exactly as it is.":
    "{date} quedará libre para otra persona, y el resto de tu reserva recurrente se mantiene exactamente igual.",
  "This date is not refunded. Your total stays {total}.":
    "Esta fecha no se reembolsa. Tu total sigue siendo {total}.",
  "Cancel this date": "Cancelar esta fecha",
  "Keep this date": "Mantener esta fecha",
  "Cancelling this booking": "Cancelar esta reserva",
  "Dates can be cancelled one at a time but are not refunded. This recurring booking is not refundable.":
    "Las fechas pueden cancelarse una a una, pero no se reembolsan. Esta reserva recurrente no es reembolsable.",
  "Cancel the whole recurring booking for a full refund until {deadline}. After that, dates can be cancelled one at a time but are not refunded.":
    "Cancela toda la reserva recurrente con reembolso completo hasta el {deadline}. Después, las fechas pueden cancelarse una a una, pero no se reembolsan.",
  "Dates can be cancelled but are not refunded. The recurring booking was refundable in full until {deadline}.":
    "Las fechas pueden cancelarse, pero no se reembolsan. La reserva recurrente era reembolsable en su totalidad hasta el {deadline}.",
  "Cancel all upcoming": "Cancelar todas las próximas",
  "Cancel booking": "Cancelar reserva",
  "Cancel this recurring booking?": "¿Cancelar esta reserva recurrente?",
  "All {count} upcoming dates will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "Las {count} fechas próximas se cancelarán y las salas quedarán libres. Se reembolsan {refund} a tu método de pago. Los reembolsos tardan de 5 a 10 días hábiles en aparecer.",
  "All 1 upcoming date will be cancelled and the rooms freed. {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "La 1 fecha próxima se cancelará y la sala quedará libre. Se reembolsan {refund} a tu método de pago. Los reembolsos tardan de 5 a 10 días hábiles en aparecer.",
  "Cancel and refund": "Cancelar y reembolsar",
  "Keep booking": "Mantener la reserva",
  "This recurring booking can no longer be refunded":
    "Esta reserva recurrente ya no puede reembolsarse",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "Una reserva recurrente es reembolsable en su totalidad hasta el {deadline}, que ya pasó. Aún puedes cancelar las {count} fechas próximas una a una, lo que libera la sala en esas fechas.",
  "A recurring booking is refundable in full until {deadline}, which has passed. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "Una reserva recurrente es reembolsable en su totalidad hasta el {deadline}, que ya pasó. Aún puedes cancelar la 1 fecha próxima, lo que libera la sala en esa fecha.",
  "This recurring booking is not refundable. You can still cancel the {count} upcoming dates one at a time, which frees the room on those dates.":
    "Esta reserva recurrente no es reembolsable. Aún puedes cancelar las {count} fechas próximas una a una, lo que libera la sala en esas fechas.",
  "This recurring booking is not refundable. You can still cancel the 1 upcoming date one at a time, which frees the room on those dates.":
    "Esta reserva recurrente no es reembolsable. Aún puedes cancelar la 1 fecha próxima, lo que libera la sala en esa fecha.",
  "Cancelled dates are not refunded. To ask for an exception, talk with the space directly.":
    "Las fechas canceladas no se reembolsan. Para pedir una excepción, habla directamente con el espacio.",
  "Back to booking": "Volver a la reserva",
  "Service Fee": "Tarifa de servicio",
  Tax: "Impuestos",
  "Refunded {date}": "Reembolsado el {date}",
  "Balance ({currency})": "Saldo ({currency})",
  "Total ({currency})": "Total ({currency})",
  "Billed to {address}": "Facturado a {address}",
  // The single booking's own page — its duration and its cancellation dialog
  "{count} hours": "{count} horas",
  "{count} days": "{count} días",
  "This booking is not refundable and can't be cancelled online. Please contact the venue if your plans change.":
    "Esta reserva no es reembolsable y no se puede cancelar en línea. Si cambian tus planes, contacta con el espacio.",
  "The cancellation window for this booking has closed, so it can no longer be cancelled online. Please contact the venue if your plans change.":
    "El plazo de cancelación de esta reserva ha terminado, así que ya no se puede cancelar en línea. Si cambian tus planes, contacta con el espacio.",
  "This booking can't be cancelled online. Please contact the venue if your plans change.":
    "Esta reserva no se puede cancelar en línea. Si cambian tus planes, contacta con el espacio.",
  "This booking is not refundable. Cancelling frees the room for someone else but returns nothing.":
    "Esta reserva no es reembolsable. Cancelarla libera la sala para otra persona, pero no se devuelve nada.",
  "Cancel this booking for a full refund of {refund}.":
    "Cancela esta reserva con un reembolso completo de {refund}.",
  "Cancelling this booking returns {percentage}% of what you paid — {refund}.":
    "Cancelar esta reserva devuelve el {percentage}% de lo que pagaste: {refund}.",
  "Cancel this booking?": "¿Cancelar esta reserva?",
  "The room will be freed for someone else. This booking is not refundable, so nothing is returned.":
    "La sala quedará libre para otra persona. Esta reserva no es reembolsable, así que no se devuelve nada.",
  "The room will be freed for someone else and {refund} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "La sala quedará libre para otra persona y se reembolsan {refund} a tu método de pago. Los reembolsos tardan de 5 a 10 días hábiles en aparecer.",
  "The room will be freed for someone else and {refund} — {percentage}% of what you paid — is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "La sala quedará libre para otra persona y se reembolsan {refund} —el {percentage}% de lo que pagaste— a tu método de pago. Los reembolsos tardan de 5 a 10 días hábiles en aparecer.",
  // The change flow — the hero's action and the three steps of its dialog
  "Change booking": "Cambiar reserva",
  "This booking can no longer be changed. To move it, talk with the space directly.":
    "Esta reserva ya no se puede cambiar. Para moverla, habla directamente con el espacio.",
  "This booking could be changed until {deadline}. To move it, talk with the space directly.":
    "Esta reserva se podía cambiar hasta {deadline}. Para moverla, habla directamente con el espacio.",
  "Move this booking": "Mover esta reserva",
  "Pick a new date and time for {room}. Everything else about your booking stays as it is.":
    "Elige una nueva fecha y hora para {room}. Todo lo demás de tu reserva queda igual.",
  "This slot costs {price} for {duration}.":
    "Este horario cuesta {price} por {duration}.",
  "This is the slot you already have. Pick a different date or time to move it.":
    "Este es el horario que ya tienes. Elige otra fecha u hora para moverla.",
  "This slot costs {amount} more, charged when you confirm.":
    "Este horario cuesta {amount} más, que se cobra al confirmar.",
  "This slot costs {amount} more. Your {card} is charged when you confirm.":
    "Este horario cuesta {amount} más. Se cobrará a tu {card} al confirmar.",
  "This slot is cheaper. {amount} is refunded to your payment method.":
    "Este horario es más barato. Se reembolsan {amount} a tu método de pago.",
  "This slot is cheaper. {amount} is refunded to your {card}.":
    "Este horario es más barato. Se reembolsan {amount} a tu {card}.",
  "This slot is cheaper, but changes are not partially refunded. Your total stays {paid}.":
    "Este horario es más barato, pero los cambios no se reembolsan parcialmente. Tu total sigue siendo {paid}.",
  "Review charge": "Revisar el cargo",
  "Review change": "Revisar el cambio",
  "Keep current slot": "Mantener el horario actual",
  "Move this booking and pay {extra}?": "¿Mover esta reserva y pagar {extra}?",
  "Move this booking?": "¿Mover esta reserva?",
  Now: "Ahora",
  "Moving to": "Se mueve a",
  "Already paid": "Ya pagado",
  "New slot price": "Precio del nuevo horario",
  "To charge now": "A cobrar ahora",
  "To refund": "A reembolsar",
  "Not refunded": "Sin reembolso",
  "Nothing to pay": "Nada que pagar",
  "Your card is charged as soon as you confirm, and the booking moves once the charge goes through.":
    "Se cobra a tu tarjeta en cuanto confirmes, y la reserva se mueve una vez que el cargo se aprueba.",
  "{amount} is refunded to your payment method. Refunds take 5–10 business days to appear.":
    "Se reembolsan {amount} a tu método de pago. Los reembolsos tardan de 5 a 10 días hábiles en aparecer.",
  "{amount} is refunded to your {card}. Refunds take 5–10 business days to appear.":
    "Se reembolsan {amount} a tu {card}. Los reembolsos tardan de 5 a 10 días hábiles en aparecer.",
  "Nothing is charged and nothing is refunded — only the date and time change.":
    "No se cobra ni se reembolsa nada: solo cambian la fecha y la hora.",
  "Nothing is charged. The {amount} difference is not refunded, so your total stays {paid}.":
    "No se cobra nada. La diferencia de {amount} no se reembolsa, así que tu total sigue siendo {paid}.",
  "Pay {amount} and move": "Pagar {amount} y mover",
  "Move booking": "Mover reserva",
  "Your booking has moved": "Tu reserva se ha movido",
  "Your new booking": "Tu nueva reserva",
  "Charged to your {card}": "Cobrado a tu {card}",
  "Charged to your payment method": "Cobrado a tu método de pago",
  "Refunded to your {card}": "Reembolsado a tu {card}",
  "Refunded to your payment method": "Reembolsado a tu método de pago",
  "Total paid": "Total pagado",
  "A new confirmation is on its way to {email}.":
    "Una nueva confirmación va en camino a {email}.",
  "{network} ending {last4}": "{network} terminada en {last4}",
  "This slot could not be priced. Try another date or time.":
    "No se pudo calcular el precio de este horario. Prueba otra fecha u hora.",
  "This booking could not be moved. Please try again.":
    "No se pudo mover esta reserva. Inténtalo de nuevo.",
  // The recurring quote refusal banner — what the quote refused and the way out
  "This time is sold at a non-refundable rate, which cannot be part of a recurring booking. Try a different day or time, or book this date on its own.":
    "Esta hora se vende con una tarifa no reembolsable, que no puede formar parte de una reserva recurrente. Prueba otro día u hora, o reserva esta fecha por separado.",
  "This promo code makes the booking non-refundable, which cannot be part of a recurring booking. Remove the code, or book this date on its own.":
    "Este código promocional hace que la reserva no sea reembolsable, por lo que no puede formar parte de una reserva recurrente. Elimina el código o reserva esta fecha por separado.",
  "Bookings at this time need the venue's approval, so they cannot repeat yet. Try a different day or time, or book this date on its own.":
    "Las reservas a esta hora necesitan la aprobación del establecimiento, así que todavía no pueden repetirse. Prueba otro día u hora, o reserva esta fecha por separado.",
  "The first date's start time has passed. Update the dates to keep this booking repeating.":
    "La hora de inicio de la primera fecha ya pasó. Actualiza las fechas para que esta reserva siga repitiéndose.",
  "The chosen dates no longer fit this room's booking window. Update the dates to keep this booking repeating.":
    "Las fechas elegidas ya no caben en la ventana de reserva de esta sala. Actualiza las fechas para que esta reserva siga repitiéndose.",
  "A recurring booking needs at least 2 dates. Add another date, or book this date on its own.":
    "Una reserva recurrente necesita al menos 2 fechas. Añade otra fecha o reserva esta fecha por separado.",
  "This room no longer offers recurring bookings. You can still book a single date.":
    "Esta sala ya no ofrece reservas recurrentes. Aún puedes reservar una sola fecha.",
  "We couldn't price this recurring booking. Try different dates, or book a single date instead.":
    "No pudimos calcular el precio de esta reserva recurrente. Prueba otras fechas o reserva una sola fecha.",
  "Update the dates": "Actualizar las fechas",
  "Book a single date instead": "Reservar una sola fecha",
  "Remove the promo code": "Eliminar el código promocional",
  Repeat: "Repetir",
  "Ends after": "Termina después de",
  "Fewer bookings": "Menos reservas",
  "More bookings": "Más reservas",
  "Checking your dates…": "Comprobando tus fechas…",
  "We couldn't check these dates. Try again.":
    "No pudimos comprobar estas fechas. Inténtalo de nuevo.",
  "This date isn't available at this time.":
    "Esta fecha no está disponible a esta hora.",
  "This date and time can't repeat inside the booking window.":
    "Esta fecha y hora no pueden repetirse dentro del período de reserva.",
  "Tinted dates are your recurring booking.":
    "Las fechas resaltadas son tu reserva recurrente.",
  "Review all {count} bookings": "Revisar las {count} reservas",
  "Review bookings": "Revisar las reservas",
  "Dates and repeat": "Fechas y repetición",
  "Choose a date": "Elige una fecha",
  "Full-day booking: the daily rate has been applied":
    "Reserva de día completo: se ha aplicado la tarifa diaria",
  Table: "Tabla",
  "Ask AI": "Ask AI",
  Beta: "Beta",
  "New chat": "Nuevo chat",
  "Ask AI ran into a problem": "Ask AI tuvo un problema",
  "Reload the page to use Ask AI.":
    "Vuelve a cargar la página para usar Ask AI.",
  "Start a new chat, or reload the page if this keeps happening.":
    "Inicia un nuevo chat o vuelve a cargar la página si sigue pasando.",
  "We couldn't verify your sign-in. Try again or refresh the page.":
    "No pudimos verificar tu inicio de sesión. Inténtalo de nuevo o actualiza la página.",
  "You don't have access to Ask AI for this account.":
    "No tienes acceso a Ask AI con esta cuenta.",
  "Ask AI is temporarily unavailable. Try again in a moment.":
    "Ask AI no está disponible temporalmente. Inténtalo de nuevo en un momento.",
  "Something went wrong while getting your answer.":
    "Algo salió mal al obtener tu respuesta.",
  "Couldn't reach Ask AI. Check your connection and try again.":
    "No se pudo conectar con Ask AI. Comprueba tu conexión e inténtalo de nuevo.",
  "The answer took too long.": "La respuesta tardó demasiado.",
  "This conversation is too long. Start a new chat.":
    "Esta conversación es demasiado larga. Inicia un nuevo chat.",
  "What would you like to know?": "¿Qué te gustaría saber?",
  "Ask about your orders, revenue and room usage.":
    "Pregunta sobre tus pedidos, ingresos y el uso de tus salas.",
  "Suggested questions": "Preguntas sugeridas",
  "Suggested follow-up questions": "Preguntas de seguimiento sugeridas",
  "How many orders have we had this month?":
    "¿Cuántos pedidos hemos tenido este mes?",
  "What was our revenue in the last 30 days?":
    "¿Cuáles fueron nuestros ingresos en los últimos 30 días?",
  "Which product types are booked the most?":
    "¿Qué tipos de producto se reservan más?",
  "How does this month's revenue compare with last month?":
    "¿Cómo se comparan los ingresos de este mes con los del mes pasado?",
  "What was meeting-room utilization last month?":
    "¿Cuál fue la ocupación de las salas de reuniones el mes pasado?",
  "What were last month's unbooked meeting-room hours worth?":
    "¿Cuánto valían las horas de salas de reuniones sin reservar el mes pasado?",
  "How does this month compare with last month?":
    "¿Cómo va este mes en comparación con el mes pasado?",
  "Ask AI conversation": "Conversación con Ask AI",
  "Jump to latest": "Ir a lo más reciente",
  "Thinking…": "Pensando…",
  "Complex questions can take up to a minute":
    "Las preguntas complejas pueden tardar hasta un minuto",
  "You stopped this answer": "Detuviste esta respuesta",
  Failed: "Falló",
  Copy: "Copiar",
  "Answer copied": "Respuesta copiada",
  "Good answer": "Buena respuesta",
  "Bad answer": "Mala respuesta",
  "What was good about this answer?": "¿Qué tuvo de bueno esta respuesta?",
  "What went wrong with this answer?": "¿Qué falló en esta respuesta?",
  Accurate: "Precisa",
  Relevant: "Relevante",
  Detailed: "Detallada",
  Other: "Otro",
  Inaccurate: "Imprecisa",
  "Not relevant": "No relevante",
  "Too vague": "Demasiado vaga",
  "Comment (optional)": "Comentario (opcional)",
  "Send feedback": "Enviar comentarios",
  "Feedback sent": "Comentarios enviados",
  "Couldn't send your feedback. Try again.":
    "No se pudieron enviar tus comentarios. Inténtalo de nuevo.",
  "Ask a question": "Haz una pregunta",
  Send: "Enviar",
  Stop: "Detener",
  "Answer ready": "Respuesta lista",
  "Ask AI from any page": "Ask AI desde cualquier página",
  "Get answers about your orders, revenue and room usage without leaving the page you're on.":
    "Obtén respuestas sobre tus pedidos, ingresos y el uso de tus salas sin salir de la página en la que estás.",
  Shortcut: "Atajo",
  "Got it": "Entendido",
  "Get insights on these orders": "Analizar estos pedidos",
  "Give me insights on these orders.": "Dame un análisis de estos pedidos.",
  "Monthly report": "Informe mensual",
  "On the 1st of each month": "El día 1 de cada mes",
  "Last month's revenue, bookings and how full your rooms were, emailed to your team. Choose who gets it, or turn it off.":
    "Los ingresos, las reservas y la ocupación de tus salas del mes pasado, enviados por correo a tu equipo. Elige quién lo recibe o desactívalo.",
  "Sent to your admins": "Enviado a tus administradores",
  "Monthly report saved.": "Informe mensual guardado.",
  "Flexspace writes and sends this email on the 1st of each month — you choose who gets it.":
    "Flexspace redacta y envía este correo el día 1 de cada mes; tú eliges quién lo recibe.",
  "Who gets it": "Quién lo recibe",
  "With no one listed, it goes to your dashboard admins.":
    "Si no hay nadie en la lista, se envía a los administradores de tu panel.",
  Search: "Buscar",
  "Review and sign agreement": "Revisar y firmar el contrato",
  "Page {current} of {total}": "Página {current} de {total}",
  "Zoom in": "Acercar",
  "Zoom out": "Alejar",
  "Membership agreement": "Contrato de membresía",
  "Membership agreement (updated)": "Contrato de membresía (actualizado)",
  "Full legal name": "Nombre legal completo",
  "Type your own full legal name, even if you are signing for a company. This signs the membership agreement.":
    "Escribe tu nombre legal completo, aunque firmes en nombre de una empresa. Con esto firmas el contrato de membresía.",
  "After you pay, we'll email you the full agreement with your signature.":
    "Después de pagar, te enviaremos por correo electrónico el contrato completo con tu firma.",
  "Scroll to the end and type your full legal name to continue.":
    "Desplázate hasta el final y escribe tu nombre legal completo para continuar.",
  "This agreement was updated while you were checking out. Please review the latest version and sign again.":
    "Este contrato se actualizó mientras completabas la compra. Revisa la versión más reciente y vuelve a firmar.",
  "Please sign the membership agreement by typing your full legal name.":
    "Firma el contrato de membresía escribiendo tu nombre legal completo.",
  "Please type your full legal name": "Escribe tu nombre legal completo",
  "The agreement could not be displayed here.":
    "No se pudo mostrar el contrato aquí.",
  "Open the agreement": "Abrir el contrato",
  "Higher rate": "Tarifa más alta",
};
